(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    // Highlight the active progress bar inside .card-gallery__progress whenever
  // the slideshow inside the same card-gallery dispatches a slideshow:select
  // event. The event bubbles, so a single document-level listener handles
  // every product card in the page (including ones inserted later via morph
  // / infinite scroll).
  if (!window.__cardGalleryProgressInit) {
    window.__cardGalleryProgressInit = true;
    document.addEventListener('slideshow:select', (event) => {
      const slideshow = event.target;
      if (!(slideshow instanceof Element)) return;
      const gallery = slideshow.closest('.card-gallery');
      if (!gallery) return;
      const progress = gallery.querySelector('.card-gallery__progress');
      if (!progress) return;
      const bars = progress.querySelectorAll('.card-gallery__progress-bar');
      const index = event.detail?.index ?? 0;
      bars.forEach((bar, i) => bar.classList.toggle('is-active', i === index));
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    // Tab switching for the Women's / Men's / Kids section at the top of the mobile drawer.
  if (!window.__menuDrawerTabsInit) {
    window.__menuDrawerTabsInit = true;
    document.addEventListener('click', function (e) {
      var tab = e.target.closest('.menu-drawer__tab');
      if (!tab) return;
      var tabBar = tab.closest('.menu-drawer__tabs');
      if (!tabBar) return;
      var nav = tabBar.closest('.menu-drawer__navigation');
      if (!nav) return;
      var index = tab.dataset.tabIndex;

      // Update active tab
      tabBar.querySelectorAll('.menu-drawer__tab').forEach(function (t) {
        var isActive = t.dataset.tabIndex === index;
        t.classList.toggle('is-active', isActive);
        t.setAttribute('aria-selected', String(isActive));
      });

      // Show/hide panels
      nav.querySelectorAll('.menu-drawer__tab-panel').forEach(function (panel) {
        panel.hidden = panel.id !== 'menu-drawer-tab-panel-' + index;
      });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media-gallery-content"] && !Shopify.designMode) return;
  try {
    // Auto-play mp4/video inside product media when the slide becomes active
  // (via swipe or variant change). Pause videos in non-active slides.
  (function () {
    if (window.__pdpVideoAutoplayInit) return;
    window.__pdpVideoAutoplayInit = true;

    function playDeferredMedia(dm) {
      if (!dm) return;
      // Load the video from <template> if not yet loaded
      if (!dm.getAttribute('data-media-loaded')) {
        if (typeof dm.loadContent === 'function') {
          dm.loadContent(false);
        }
      }
      // Play via the component method or directly
      if (typeof dm.playMedia === 'function') {
        dm.playMedia();
      } else {
        var video = dm.querySelector('video');
        if (video) {
          video.muted = true;
          video.play().catch(function() {});
        }
      }
    }

    function pauseDeferredMedia(dm) {
      if (!dm) return;
      if (typeof dm.pauseMedia === 'function') {
        dm.pauseMedia();
      } else {
        var video = dm.querySelector('video');
        if (video) video.pause();
      }
    }

    function handleSlideSelect(event) {
      var slideshow = event.target;
      if (!(slideshow instanceof Element)) return;
      var gallery = slideshow.closest('media-gallery');
      if (!gallery) return;

      var slides = gallery.querySelectorAll('slideshow-slide');
      slides.forEach(function(slide, i) {
        var dm = slide.querySelector('deferred-media');
        if (!dm) return;
        if (i === event.detail.index) {
          playDeferredMedia(dm);
        } else {
          pauseDeferredMedia(dm);
        }
      });
    }

    // Listen for slide changes (bubbles from slideshow-component)
    document.addEventListener('slideshow:select', handleSlideSelect);

    // After variant update replaces the media gallery, auto-play any video
    // in the first visible slide.
    function autoPlayFirstVideo(gallery) {
      if (!gallery) return;
      // Small delay to let the new DOM settle
      requestAnimationFrame(function() {
        var activeSlide = gallery.querySelector('slideshow-slide[aria-hidden="false"]')
                       || gallery.querySelector('slideshow-slide:first-child');
        if (activeSlide) {
          var dm = activeSlide.querySelector('deferred-media');
          if (dm) playDeferredMedia(dm);
        }
      });
    }

    // Watch for new media-gallery elements being added to the DOM
    // (variant changes use replaceWith, inserting a fresh element)
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        m.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && node.tagName === 'MEDIA-GALLERY') {
            autoPlayFirstVideo(node);
          }
          // Also check children (e.g. if gallery is nested)
          if (node.nodeType === 1 && node.querySelector) {
            var nested = node.querySelector('media-gallery');
            if (nested) autoPlayFirstVideo(nested);
          }
        });
      });
    });

    // Observe the product section container for gallery replacements
    var productSection = document.querySelector('.product-information');
    if (productSection) {
      observer.observe(productSection, { childList: true, subtree: true });
    }

    // Also auto-play on initial page load for the first visible video
    document.addEventListener('DOMContentLoaded', function() {
      document.querySelectorAll('media-gallery').forEach(autoPlayFirstVideo);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
